import React, { Fragment } from 'react';
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  ListItemIcon,
} from '@material-ui/core';
import { Link as LinkIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import { Filters } from '../../services/Filters';

const _filters = new Filters();

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.primary.main,
  },
  content: {
    color: theme.palette.primary.contrastText,
  }
});

const Overview = props => {
  const {title, moduleData, route, style, appLanguage, classes} = props;

  const handleItemClick = (e, id, url) => {
    if(url) {
      _filters.urlIcon(url);
      onExternalLink(e, url);
    } else {
      props.onSelected(id);
    }
  }

  const onExternalLink = (e, url) => {
    e.preventDefault();
    window.open(url);
  }

  // just the first 3 items
  const latestItems = (data) => {
    const items = data.slice(0, 3).map((item) => {
      const url = item.url ? item.url : item.link;
      const date = item.start_ts 
        ? _filters.startEndDate(item.start_ts, item.end_ts)
        : item.date && item.type !== "kamar"
          ? _filters.startEndDate(item.date, item.date)
          : null;
      const kamarDate = item.type
        ? _filters.startEndDate(item.date, item.type)
        : _filters.startEndDate(item.date, item.date);
      const heading = item.header
        ? item.header
        : item.name
          ? item.name
          : kamarDate;
      return (
        <ListItem
          key={item.id}
          dense
          divider
          button
          onClick={(e) => handleItemClick(e, item.id, _filters.translate(url, appLanguage))}  
        >
          <ListItemIcon>{props.itemIcon ? props.itemIcon : <LinkIcon/>}</ListItemIcon>
          <ListItemText primary={_filters.translate(heading, appLanguage)} secondary={date} primaryTypographyProps={{noWrap: true}}/>
        </ListItem>
      )
    });
    return items;
  }

  return (
    
    <Fragment>
      <Card 
        style={{minHeight: 100, height: '100%', position: 'relative', paddingBottom: 45, ...style}}
      >
        <CardHeader
          align='center'
          title={title}
          titleTypographyProps={{variant: 'subtitle1'}}
          classes={{
            root: classes.root,
            title: classes.content
          }}
        />
        <CardContent style={{paddingTop: 0}}>
          {
            moduleData.length > 0 ? (
              moduleData[0].noItems
              ? <List dense><ListItem><ListItemText primary={moduleData[0].noItems} /></ListItem></List>
              : <Fragment>
                  <List>
                    {latestItems(moduleData)}
                  </List>
                </Fragment>
            ) : (
              <Grid container justify='center' alignContent='center' style={{paddingTop: 20}}>
                <Grid item>
                  <CircularProgress />
                </Grid>
              </Grid>
            )
          }
        </CardContent>
        <CardActions style={{position: 'absolute', bottom: 10, right: 10}}>
          { moduleData.length > 2 ?
            <Button
              variant='contained'
              size='small'
              component={Link}
              to={route}
            >
              View more..
            </Button>
            : null
          }
        </CardActions>
      </Card>
    </Fragment>
  )
}

export default withStyles(styles)(Overview);


// WEBPACK FOOTER //
// ./src/components/home/Overview.js